// Gecmis surumlerde token, role, role_name ve isAdmin localStorage'a
// yaziliyordu. Artik auth tamamen HttpOnly cookie ile yapiliyor ve bu
// alanlarin hicbiri yazilmiyor; buradaki silme mantigi yalnizca eski
// kurulumlardan kalan kayitlari temizlemek icin duruyor (migration).
// Bir sure sonra bu yardimci da kaldirilabilir.
const LEGACY_KEYS = ["token", "role", "role_name", "isAdmin"];

export const clearLegacyAuthStorage = () => {
  try {
    for (const key of LEGACY_KEYS) {
      localStorage.removeItem(key);
    }
  } catch {
    // private mode vs.
  }
};
